export const YIELD_SCHEDULER_ROUTE_PATHS = {
  yieldScheduler: '/yield-scheduler',
};
